//
import {
  DOCUMENTOS_GET_DOCUMENTACION,
  DOCUMENTOS_GET_DOCUMENTACION_SUCCESS,
  DOCUMENTOS_GET_DOCUMENTACION_FAIL,
  DOCUMENTOS_GET_DOCUMENTO,
  DOCUMENTOS_GET_DOCUMENTO_SUCCESS,
  DOCUMENTOS_GET_DOCUMENTO_FAIL,
  DOCUMENTOS_SET_IDRELPERDOC,
  DOCUMENTOS_UNSET_REFRESH,
  DOCUMENTOS_ADD_DOCUMENTO,
  DOCUMENTOS_ADD_DOCUMENTO_SUCCESS,
  DOCUMENTOS_ADD_DOCUMENTO_FAIL,
  DOCUMENTOS_UPDATE_DOCUMENTO,
  DOCUMENTOS_UPDATE_DOCUMENTO_SUCCESS,
  DOCUMENTOS_UPDATE_DOCUMENTO_FAIL,
  DOCUMENTOS_DEL_DOCUMENTO,
  DOCUMENTOS_DEL_DOCUMENTO_SUCCESS,
  DOCUMENTOS_DEL_DOCUMENTO_FAIL,
  DOCUMENTOS_UPDATE_LISTADOCUMENTOS,
  DOCUMENTOS_UPDATE_LISTADOCUMENTOS_SUCCESS,
  DOCUMENTOS_UPDATE_LISTADOCUMENTOS_FAIL,
  DOCUMENTOS_UPLOAD_FILE,
  DOCUMENTOS_UPLOAD_FILE_SUCCESS,
  DOCUMENTOS_UPLOAD_FILE_FAIL,
} from "./actionTypes"

export const postDocumentosUploadFile = (jsonparameters, formData) => ({
  type: DOCUMENTOS_UPLOAD_FILE,
  payload: { jsonparameters, formData },
})
export const postDocumentosUploadFileSuccess = data => ({
  type: DOCUMENTOS_UPLOAD_FILE_SUCCESS,
  payload: { data },
})
export const postDocumentosUploadFileFail = error => ({
  type: DOCUMENTOS_UPLOAD_FILE_FAIL,
  payload: error,
})

export const postDocumentosAddDocumento = jsonparameters => ({
  type: DOCUMENTOS_ADD_DOCUMENTO,
  payload: { jsonparameters },
})
export const postDocumentosAddDocumentoSuccess = data => ({
  type: DOCUMENTOS_ADD_DOCUMENTO_SUCCESS,
  payload: { data },
})
export const postDocumentosAddDocumentoFail = error => ({
  type: DOCUMENTOS_ADD_DOCUMENTO_FAIL,
  payload: error,
})

export const putDocumentosUpdateListaDocumentos = jsonparameters => ({
  type: DOCUMENTOS_UPDATE_LISTADOCUMENTOS,
  payload: { jsonparameters },
})
export const putDocumentosUpdateListaDocumentosSuccess = data => ({
  type: DOCUMENTOS_UPDATE_LISTADOCUMENTOS_SUCCESS,
  payload: { data },
})
export const putDocumentosUpdateListaDocumentosFail = error => ({
  type: DOCUMENTOS_UPDATE_LISTADOCUMENTOS_FAIL,
  payload: error,
})

export const putDocumentosUpdateDocumento = jsonparameters => ({
  type: DOCUMENTOS_UPDATE_DOCUMENTO,
  payload: { jsonparameters },
})
export const putDocumentosUpdateDocumentoSuccess = data => ({
  type: DOCUMENTOS_UPDATE_DOCUMENTO_SUCCESS,
  payload: { data },
})
export const putDocumentosUpdateDocumentoFail = error => ({
  type: DOCUMENTOS_UPDATE_DOCUMENTO_FAIL,
  payload: error,
})

export const delDocumentosDelDocumento = jsonparameters => ({
  type: DOCUMENTOS_DEL_DOCUMENTO,
  payload: { jsonparameters },
})
export const delDocumentosDelDocumentoSuccess = () => ({
  type: DOCUMENTOS_DEL_DOCUMENTO_SUCCESS,
})
export const delDocumentosDelDocumentoFail = error => ({
  type: DOCUMENTOS_DEL_DOCUMENTO_FAIL,
  payload: error,
})

export const setDocumentosid_Relacion_Persona_Documento = data => ({
  type: DOCUMENTOS_SET_IDRELPERDOC,
  payload: { data },
})

export const unsetDocumentosRefreshListaDocs = () => ({
  type: DOCUMENTOS_UNSET_REFRESH,
})

export const unsetDocumentosNotificacion = () => ({
  type: DOCUMENTOS_UNSET_REFRESH,
})

export const getDocumentosDocumentacion = jsonparameters => ({
  type: DOCUMENTOS_GET_DOCUMENTACION,
  payload: { jsonparameters },
})
export const getDocumentosDocumentacionSuccess = data => ({
  type: DOCUMENTOS_GET_DOCUMENTACION_SUCCESS,
  payload: { data },
})
export const getDocumentosDocumentacionFail = error => ({
  type: DOCUMENTOS_GET_DOCUMENTACION_FAIL,
  payload: error,
})

export const getDocumentosDocumento = jsonparameters => ({
  type: DOCUMENTOS_GET_DOCUMENTO,
  payload: { jsonparameters },
})
export const getDocumentosDocumentoSuccess = data => ({
  type: DOCUMENTOS_GET_DOCUMENTO_SUCCESS,
  payload: { data },
})
export const getDocumentosDocumentoFail = error => ({
  type: DOCUMENTOS_GET_DOCUMENTO_FAIL,
  payload: error,
})
export const getDocumentosUnsetDocumento = data => ({
  type: DOCUMENTOS_GET_DOCUMENTO_SUCCESS,
  payload: { data },
})
